const BASE_KEY = "si-lists";

const SELECTION_KEY = "selection";
const CONFIG_KEY = "config";
const TAG_COLUMN_QUERY_KEY = "tags";

export const listsQueryKeys = {
    columnSelection: () => [BASE_KEY, SELECTION_KEY] as const,

    columnsConfig: () => [BASE_KEY, CONFIG_KEY] as const,

    getTags: (listId: string) => [BASE_KEY, TAG_COLUMN_QUERY_KEY, listId] as const,
} as const;
